import React from "react";
import { Navigate } from "react-router-dom";
//Tables

import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";

//login
import ApiKey from "../pages/APIKey/index";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

//MenuInfo

import ResetPassword from "../pages/Authentication/ResetPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";
import PasswordChange from "../pages/Authentication/PasswordChange";

import Registergetlist from "../pages/Authentication/Registergetlist";
import Rolesadminget from "../pages/Authentication/Rolesadminget";

import CustomerReport from "../pages/CustomerReport/CustomerReport";

import PosLayout from "../OrderingSystem/POS/Layout/page/PosLayout";
import MenuItem from "../OrderingSystem/Menu/page/MenuItem";
import Waiter from "../OrderingSystem/Waiter/page/Waiter";
import Category from "../OrderingSystem/Category/page/Category";
import CategoryCreate from "../OrderingSystem/Category/component/CategoryCreate";
import Customers from "../OrderingSystem/Customer/page/Customers";
import ItemDetail from "../OrderingSystem/Menu/component/ItemDetail";
import CategoryDetail from "../OrderingSystem/Category/page/CategoryDetail";
import TableList from "../OrderingSystem/Table/page/TableList";
import CreateTable from "../OrderingSystem/Table/component/CreateTable";
import OrderList from "../OrderingSystem/Order/page/OrderList";
import OrderDetail from "../OrderingSystem/Order/page/OrderDetail";
import CustomerDetail from "../OrderingSystem/Customer/page/CustomerDetail";
import TenantOrganization from "../OrderingSystem/Tenant/TenantOrganization";
import Organization from "../OrderingSystem/Organization/page/Organization";
import TenantDetail from "../OrderingSystem/Tenant/component/TenantDetail";

import PaymentReport from "../OrderingSystem/PaymentReport/page/PaymentReport";
import PaymentDatBook from "../OrderingSystem/PaymentReport/page/PaymentDayBook";
import Section from "../OrderingSystem/Section/page/Section";
import DetailSection from "../OrderingSystem/Section/page/DetailSection";
import DetailTable from "../OrderingSystem/Table/page/DetailTable";
import Unit from "../OrderingSystem/Unit/page/Unit";
import CustomerType from "../OrderingSystem/CustomerType/page/CustomerType";
import ItemForm from "../OrderingSystem/Menu/component/ItemForm";
import CostCenter from "../OrderingSystem/CostCenter/page/CostCenter";
import SalesReport from "../OrderingSystem/SalesReport/page/SalesReport";
import ReturnBillLogs from "../OrderingSystem/SalesReport/page/ReturnBillLogs";
import GeneratePrintToken from "../OrderingSystem/GeneratePrintToken/page/GeneratePrintToken";
import CreditLog from "../OrderingSystem/PaymentReport/page/CreditLog";
import OrderDetailsList from "../OrderingSystem/Order/page/OrderDetailsList";
import ComplimentryLog from "../OrderingSystem/ComplimentryLogs/page/ComplimentryLog";
import DetailComplementry from "../OrderingSystem/ComplimentryLogs/component/DetailComplementry";
import Register from "../pages/Authentication/Register";
import SalesReportWise from "../OrderingSystem/SalesReport/page/SalesReportWise";
import CreditLogSummary from "../OrderingSystem/PaymentReport/page/CreditLogSummary";
import Purchase from "../OrderingSystem/Purchase/Purchase";
import PurchaseForm from "../OrderingSystem/Purchase/component/PurchaseForm";
import Supplier from "../OrderingSystem/Supplier/Supplier";
import SupplierForm from "../OrderingSystem/Supplier/component/SupplierForm";
import PurchaseDetail from "../OrderingSystem/Purchase/component/PurchaseDetail";
import OrgPage from "../OrderingSystem/QRMenu/OrgPage";
import LandingPage from "../OrderingSystem/Landing/page/LandingPage";
import DaybookOrderSummary from "../Daybook/page/DaybookOrderSummary";
import PaymentTypeSummary from "../Daybook/page/PaymentTypeSummary";
import RecipeList from "../OrderingSystem/RecipeManagement/page/RecipeList";
import RecipeForm from "../OrderingSystem/RecipeManagement/component/RecipeForm";
import ReceipeDetail from "../OrderingSystem/RecipeManagement/component/ReceipeDetail";
import UnitConversion from "../OrderingSystem/Unit/page/UnitConversion";
import DayBookLogs from "../OrderingSystem/PaymentReport/page/DayBookLogs";
import DaybookLogDetail from "../OrderingSystem/PaymentReport/component/DaybookLogDetail";
import ItemPercentDetailReport from "../OrderingSystem/SalesReport/component/ItemPercentDetailReport";
import TransactionReport from "../OrderingSystem/SalesReport/page/TransactionReport";
import Dbmgmt from "../pages/DatabaseWebservice/DatabaseMgmt/page/Dbmgmt";
import DbDetailPage from "../pages/DatabaseWebservice/DatabaseMgmt/page/DbdetailPage";
import RestroUsersInfo from "../pages/DatabaseWebservice/RestroUsersInfo/page/RestroUsersInfo";
import RestroDetailPage from "../pages/DatabaseWebservice/RestroUsersInfo/page/RestroDetailPage";
import RestroUserLogs from "../pages/DatabaseWebservice/RestoUserLogs/page/RestroUserLogs";
import RestroUserLogsDetail from "../pages/DatabaseWebservice/RestoUserLogs/page/RestroUserLogsDetail";
import RestroUserQueryLogs from "../pages/DatabaseWebservice/RestroUserQueryLogs/page/RestroUserQueryLogs";
import DbdetailPage from "../pages/DatabaseWebservice/DatabaseMgmt/page/DbdetailPage";
import Usermanagement from "../pages/DatabaseWebservice/User-management/pages/Usermanagement";
import Userdetail from "../pages/DatabaseWebservice/User-management/pages/Userdetail";
import RestroUserInfoForm from "../pages/DatabaseWebservice/RestroUsersInfo/component/RestroUserInfoForm";
import RUIValidTillExtend from "../pages/DatabaseWebservice/RestroUsersInfo/page/RUIValidTillExtend";
import AllTask from "../pages/DatabaseWebservice/Tasks/AllTask";
import PageList from "../Kangaroo/PagesSection/page/PageList";
import PageForm from "../Kangaroo/PagesSection/page/PageForm";
import MediaList from "../Kangaroo/Media/page/MediaList";
import Team from "../Kangaroo/Team/page/Team";
import Testimonial from "../Kangaroo/Testimonial/page/Testimonial";
import Branch from "../Kangaroo/Branch/page/Branch";
import Destination from "../Kangaroo/Destination/page/Destination";
import Faqs from "../Kangaroo/FAQs/page/FAQs";
import Blog from "../Kangaroo/Blog/page/Blog";
import Privacy from "../Kangaroo/Privacy/page/Privacy";
import AffiliatedInstitute from "../Kangaroo/AffiliatedInstitute/GridView";
import StudentForms from "../Kangaroo/StudentForms";
import SimplePage from "../Kangaroo/Team/page/SimplePage";
import Settings from "../Kangaroo/Team/page/ProfileSetting";
import Course from "../Kangaroo/Courses/page/Course";
import CourseForm from "../Kangaroo/Courses/component/CourseForm";
import Menu from "../Kangaroo/MenuSetup/page/Menu";
import BlogCreate from "../Kangaroo/Blog/page/BlogCreate";
import TestimonialForm from "../Kangaroo/Testimonial/page/TestimonialForm";
import CourseDetail from "../Kangaroo/Courses/component/CourseDetail";
import StudentForm from "../Kangaroo/StudentForms/component/StudentForm";
import BranchFormPage from "../Kangaroo/Branch/component/Add Branch";
import BranchDetail from "../Kangaroo/Branch/page/BranchDetail";
import PrivacyForm from "../Kangaroo/Privacy/component/PrivacyForm";
import PrivacyDetail from "../Kangaroo/Privacy/component/PrivacyDetail";
import Tag from "../Kangaroo/Tag/Tag";
import AffiliateInstitute from "../Kangaroo/AffiliatedInstitute/Page/AffiliateInstitute";
import AddInstitute from "../Kangaroo/AffiliatedInstitute/Page/AddInstitute";
import AffiliatedInstitutes from "../Kangaroo/AffiliatedInstitute/Page/AffiliateInstitute";
import NewsList from "../Kangaroo/News/NewsList";
import NewsForm from "../Kangaroo/News/component/NewsForm";
import Event from "../Kangaroo/Event/Event";
import EventForm from "../Kangaroo/Event/component/EventForm";
import InstituteDetail from "../Kangaroo/AffiliatedInstitute/Page/InstituteDetail";
import PageDetail from "../Kangaroo/PagesSection/page/PageDetail";
import BlogDetail from "../Kangaroo/Blog/page/BlogDetail";
import NewsDetail from "../Kangaroo/News/component/NewsDetail";
import EventDetail from "../Kangaroo/Event/component/EventDetail";
import TestimonialDetail from "../Kangaroo/Testimonial/page/TestimonialDetail";
import StudentDetail from "../Kangaroo/StudentForms/StudentDetail";
import DestinationForm from "../Kangaroo/Destination/component/DestinationForm";
import DestinationDetail from "../Kangaroo/Destination/component/DestinationDetail";
import PageEditor from "../Kangaroo/PagesSection/page/PageEditor";
import Role from "../Kangaroo/Roles/Page/Role";
import FaqCreate from "../Kangaroo/FAQs/component/FaqCreate";
import FAQGroup from "../Kangaroo/FAQs/page/FAQGroup";
import TagDetail from "../Kangaroo/Tag/TagDetail";
import User from "../Kangaroo/User/page/User";
import TestPreparation from "../Kangaroo/TestPreparation/page/TestPreparation";
import TestDetail from "../Kangaroo/TestPreparation/page/TestDetail";
import TestCreate from "../Kangaroo/TestPreparation/page/TestCreate";
import Partners from "../Kangaroo/Partner/Partners";
import PartnerForm from "../Kangaroo/Partner/PartnerForm";
import PartnerDetails from "../Kangaroo/Partner/PartnerDetails";
import Home from "../Kangaroo/HomeSection/Home";
import HomeSectionForm from "../Kangaroo/HomeSection/HomeSectionForm";
import HomeSectionDetail from "../Kangaroo/HomeSection/HomeSectionDetail";
import Video from "../Kangaroo/Videos/Video";
import VideoForm from "../Kangaroo/Videos/VideoForm";
import VideoDetails from "../Kangaroo/Videos/VideoDetails";
import MenuCreate from "../Kangaroo/MenuSetup/page/MenuCreate";
import MediaGroup from "../Kangaroo/Media/page/MediaGroup";
import Timeline from "../Kangaroo/Timeline/Timeline";
import AddTimeline from "../Kangaroo/Timeline/AddTimeline";
import JobGrid from "../Kangaroo/JobListing/page/JobList";
import JobDetail from "../Kangaroo/JobListing/page/JobDetail";
import Timelinedetail from "../Kangaroo/Timeline/Timelinedetail";
import AddJob from "../Kangaroo/JobListing/page/JobForm";
import BannerSection from "../Kangaroo/BannerSection/BannerSection";
import BannerForm from "../Kangaroo/BannerSection/BannerForm";
import Scorecalculator from "../Kangaroo/Calculator/page/scorecalculator";
import JobApplication from "../Kangaroo/JobApplication/JobApplication";
import JobAppDetail from "../Kangaroo/JobApplication/JobAppDetail";
import FranchiseEnquiry from "../Kangaroo/FranchiseEnquiry/page/FranchiseEnquiry";
import FranchiseForm from "../Kangaroo/FranchiseEnquiry/page/FranchiseForm";
import NewsLetter from "../Kangaroo/NewsLetter/page/NewsLetter";
import NewsLetterForm from "../Kangaroo/NewsLetter/component/NewsLetterForm";
import TermsCondition from "../Kangaroo/Privacy/page/TermsCondition";
import TermsForm from "../Kangaroo/Privacy/component/TermsForm";
import EventFormList from "../Kangaroo/Event/EventFormList";
import Dashboard from "../Kangaroo/DashboardKangaroo/Dashboard";
import FooterInfo from "../Kangaroo/FooterInfo/page/FooterInfo";
import FooterInfoForm from "../Kangaroo/FooterInfo/component/FooterInfoForm";
import Whoweare from "../Kangaroo/WhoWeAre/Page/Whoweare";
import AddWhoWeAre from "../Kangaroo/WhoWeAre/Component/AddWhoWeAre";
import Whowearedetail from "../Kangaroo/WhoWeAre/Page/Whowearedetail";
import CEOmessage from "../Kangaroo/MessageFromCEO/Page/CEOmessage";
import Messageform from "../Kangaroo/MessageFromCEO/Component/Messageform";
import MessageDetails from "../Kangaroo/MessageFromCEO/Component/MessageDetails";
import ClearStudentForm from "../Kangaroo/StudentForms/ClearStudentForm";
import EmailRecipient from "../Kangaroo/EmailConfig/EmailRecipient";
import EmailConfig from "../Kangaroo/EmailConfig/EmailConfig";
import ChannelPartner from "../KEFIntelligence/ChannelPartner/page/ChannelPartner";
import ChannelPartnerInstitute from "../KEFIntelligence/ChannelPartnerInstitute/page/ChannelPartnerInstitute";
import InstituteIntellForm from "../Kangaroo/AffiliatedInstitute/Component/InstituteIntellForm";
import Widget from "../KEFIntelligence/Widget/page/Widget";
import WidgetForm from "../KEFIntelligence/Widget/component/WidgetForm";
import DestinationIntellForm from "../Kangaroo/Destination/component/DestinationIntellForm";
import InstituteWidget from "../KEFIntelligence/Widget/page/InstituteWidget";
import DestinationWidget from "../KEFIntelligence/Widget/page/DestinationWidget";
import ProductService from "../KEFIntelligence/ProductService/page/ProductService";
import ProductServiceForm from "../KEFIntelligence/ProductService/component/ProductServiceForm";
import GeneralPages from "../KEFIntelligence/GeneralPages/GeneralPages";
import FranchisePrivate from "../Kangaroo/FranchiseEnquiry/page/FranchisePrivate";

//ApprovedList

const authProtectedRoutes = [
  { path: "/home", component: <Navigate to="/project" /> },

  //Tables

  { path: "/dashboard", component: <Dashboard /> },

  //APIkey
  { path: "/apps-api-key", component: <ApiKey /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/Admin-roles", component: <Rolesadminget /> },
  { path: "/User-Role", component: <Registergetlist /> },
  { path: "/User-Role/create", component: <Register /> },
  { path: "/User-Role/edit/:id", component: <Register /> },
  // { path: "/Yup", component: <YupValidation /> },
  { path: "/change-password", component: <ChangePassword /> },

  { path: "/customer-report", component: <CustomerReport /> },

  // ==================================================
  // Kangaroo Education Foundation
  { path: "/customer-list", component: <Customers /> },
  // { path: "/user-mgmt", component: <Usermanagement/> },
  { path: "/user-mgmt", component: <Usermanagement /> },
  { path: "/tasks", component: <AllTask /> },

  {
    path: "/customer/:id",
    component: <CustomerDetail />,
  },

  { path: "/staff", component: <Waiter /> },
  { path: "/category-list", component: <Category /> },
  { path: "/db", component: <Dbmgmt /> },
  { path: "/restrousers", component: <RestroUsersInfo /> },
  { path: "/restrouserslogs", component: <RestroUserLogs /> },
  { path: "/restrousersquerylogs", component: <RestroUserQueryLogs /> },

  {
    path: "/User/:id",
    component: <Userdetail />,
  },

  {
    path: "/category/create",
    component: <CategoryCreate />,
  },
  {
    path: "/category/update/:id",
    component: <CategoryCreate />,
  },
  {
    path: "/restrouserinfo/update/:apiKey",
    component: <RestroUserInfoForm />,
  },
  {
    path: "/restrouserinfo/extend/:apiKey",
    component: <RUIValidTillExtend />,
  },
  {
    path: "/category-detail/:id",
    component: <CategoryDetail />,
  },
  { path: "/menu-item", component: <MenuItem /> },
  { path: "/menu-item/create", component: <ItemForm /> },
  { path: "/menu-item/update/:id", component: <ItemForm /> },

  {
    path: "/item/detail/:id",
    component: <ItemDetail />,
  },
  { path: "/table", component: <TableList /> },
  { path: "/table/create", component: <CreateTable /> },
  { path: "/table/update/:id", component: <CreateTable /> },
  { path: "/table/detail/:id", component: <DetailTable /> },

  { path: "/order", component: <OrderList /> },
  { path: "/order-detail", component: <OrderDetailsList /> },
  {
    path: "/order/:id",
    component: <OrderDetail />,
  },

  { path: "/tenant", component: <TenantOrganization /> },
  { path: "/tenant/detail/:id", component: <TenantDetail /> },

  { path: "/organization", component: <Organization /> },

  { path: "/pos", component: <PosLayout /> },
  { path: "/payment/statement", component: <PaymentReport /> },
  { path: "/day-book", component: <PaymentDatBook /> },

  // payment type page

  { path: "/section", component: <Section /> },
  { path: "/section/detail/:id", component: <DetailSection /> },

  { path: "/unit", component: <Unit /> },
  { path: "/unit-conversion", component: <UnitConversion /> },
  { path: "/customer-type", component: <CustomerType /> },

  { path: "/cost-center", component: <CostCenter /> },
  { path: "/sales-report", component: <SalesReport /> },
  { path: "/sales-report/wise", component: <SalesReportWise /> },
  { path: "/transaction/report", component: <TransactionReport /> },
  { path: "/transaction/report/:id", component: <TransactionReport /> },

  { path: "/return-bill-report", component: <ReturnBillLogs /> },
  { path: "/generate-print-token", component: <GeneratePrintToken /> },

  { path: "/credit-logs/customer/:id", component: <CreditLog /> },
  { path: "/credit-logs/summary", component: <CreditLogSummary /> },

  { path: "/complimentry-logs", component: <ComplimentryLog /> },
  { path: "/complimentry-logs/detail/:id", component: <DetailComplementry /> },

  { path: "/purchase", component: <Purchase /> },
  { path: "/purchase/create", component: <PurchaseForm /> },
  { path: "/purchase/update/:id", component: <PurchaseForm /> },
  { path: "/purchase/detail/:id", component: <PurchaseDetail /> },

  { path: "/suppliers", component: <Supplier /> },
  { path: "/suppliers/create", component: <SupplierForm /> },
  { path: "/suppliers/update/:id", component: <SupplierForm /> },

  { path: "/dayclose/order-summary", component: <DaybookOrderSummary /> },
  { path: "/dayclose/payment-type-summary", component: <PaymentTypeSummary /> },

  // receipe management-----------------------------
  { path: "/receipe-management", component: <RecipeList /> },
  { path: "/receipe-management/create", component: <RecipeForm /> },
  { path: "/receipe-management/update/:id", component: <RecipeForm /> },
  { path: "/receipe/detail/:id", component: <ReceipeDetail /> },
  { path: "/db/detail/:id", component: <DbdetailPage /> },
  { path: "/restro/detail/:apiKey", component: <RestroDetailPage /> },
  { path: "/restrolog/detail/:apiKey", component: <RestroUserLogsDetail /> },
  // { path: "/restrouserssummary", component: <RestroUserLogsSummary /> },
  // { path: "/users-expired", component: <Restrouserexpired /> },

  { path: "/logs/day-book", component: <DayBookLogs /> },
  { path: "/logs/day-book/:id", component: <DaybookLogDetail /> },

  { path: "/percent-wise-item/all/", component: <ItemPercentDetailReport /> },

  // kangarooo
  { path: "/pages-list", component: <PageList /> },
  { path: "/pages-list/:id", component: <PageDetail /> },
  { path: "/pages/create", component: <PageForm /> },
  { path: "/pages/update/:id", component: <PageForm /> },
  { path: "/media-list", component: <MediaList /> },
  { path: "/media/create", component: <PageForm /> },
  { path: "/media/update/:id", component: <PageForm /> },
  { path: "/video-list", component: <Video /> },
  { path: "/video-form", component: <VideoForm /> },
  { path: "/video-list/details/:id", component: <VideoDetails /> },

  { path: "/team", component: <Team /> },
  { path: "/view-profile", component: <SimplePage /> },
  { path: "/profile-settings", component: <Settings /> },
  { path: "/faq", component: <Faqs /> },

  { path: "/faq-group", component: <FAQGroup /> },
  { path: "/testimonial", component: <Testimonial /> },
  { path: "/branch", component: <Branch /> },
  { path: "/joblisting", component: <JobGrid /> },
  { path: "/joblisting/create", component: <AddJob /> },
  { path: "/joblisting/update/:id", component: <AddJob /> },
  { path: "/joblisting/detail/:id", component: <JobDetail /> },

  // { path: "/calculator", component: <Scorecalculator /> },

  { path: "/calculator", component: <Scorecalculator /> },

  { path: "/addbranch/:id?", component: <BranchFormPage /> },
  { path: "/branch/:id", component: <BranchDetail /> },
  // { path: "/destination", component: <Destination /> },
  { path: "/blog", component: <Blog /> },
  { path: "/blog/:id", component: <BlogDetail /> },
  { path: "/blog/create", component: <BlogCreate /> },
  { path: "/blog/update/:id", component: <BlogCreate /> },

  { path: "/system-setup", component: <Privacy /> },
  { path: "/terms-condition", component: <TermsCondition /> },
  // { path: "/affiliate-institute", component: <AffiliatedInstitute /> },
  { path: "/student-forms", component: <StudentForms /> },
  { path: "/student-forms/create", component: <StudentForm /> },
  { path: "/student-forms/update/:id", component: <StudentForm /> },
  { path: "/student-details/:id", component: <StudentDetail /> },
  { path: "/homesection", component: <Home /> },
  { path: "/homesection-form", component: <HomeSectionForm /> },
  { path: "/homesection-form/:id", component: <HomeSectionForm /> },
  { path: "/homesection/detail/:slug", component: <HomeSectionDetail /> },

  { path: "/timeline", component: <Timeline /> },
  { path: "/timeline/create", component: <AddTimeline /> },
  { path: "/timeline/edit/:id", component: <AddTimeline /> },
  { path: "/timeline/details/:id", component: <Timelinedetail /> },

  { path: "/courses", component: <Course /> },
  { path: "/course/create", component: <CourseForm /> },
  { path: "/menu", component: <Menu /> },
  { path: "/courses/:id", component: <CourseDetail /> },
  { path: "/course/create/:id?", component: <CourseForm /> },
  { path: "/menu", component: <Menu /> },
  { path: "/institute", component: <AffiliatedInstitutes /> },
  { path: "/affiliateinstitute-form", component: <AddInstitute /> },
  { path: "/affiliateinstitute-form/update/:id", component: <AddInstitute /> },
  { path: "/institute-detail/:id", component: <InstituteDetail /> },
  { path: "/testimonial-detail/:id", component: <TestimonialDetail /> },
  { path: "/roles", component: <Role /> },
  { path: "/who-we-are", component: <Whowearedetail /> },
  { path: "/Who-we-are/create", component: <AddWhoWeAre /> },
  { path: "/Who-we-are/update/:slug", component: <AddWhoWeAre /> },
  { path: "/Who-we-are/details/:slug", component: <Whowearedetail /> },
  { path: "/message-from-ceo", component: <CEOmessage /> },
  { path: "/message-from-ceo/details/:slug", component: <MessageDetails /> },
  { path: "/message-from-ceo/create", component: <Messageform /> },
  { path: "/message-from-ceo/update/:id", component: <Messageform /> },

  {
    path: "/testimonialform",
    component: <TestimonialForm />,
  },
  {
    path: "/testimonialform/update/:id",
    component: <TestimonialForm />,
  },
  {
    path: "/system-setup/update/:id",
    component: <PrivacyForm />,
  },
  {
    path: "/terms-condition/update/:id",
    component: <TermsForm />,
  },
  {
    path: "/terms-condition/detail/:id",
    component: <PrivacyDetail />,
  },
  {
    path: "/system-setup/detail/:id",
    component: <PrivacyDetail />,
  },
  {
    path: "/system-setup/create",
    component: <PrivacyForm />,
  },
  {
    path: "/tag",
    component: <Tag />,
  },
  {
    path: "/partners",
    component: <Partners />,
  },

  {
    path: "/addpartner",
    component: <PartnerForm />,
  },
  {
    path: "/partnerdetails/:id",
    component: <PartnerDetails />,
  },
  {
    path: "/addpartner/:id",
    component: <PartnerForm />,
  },
  {
    path: "/tag/detail/:id",
    component: <TagDetail />,
  },
  {
    path: "/news",
    component: <NewsList />,
  },
  {
    path: "/news/:id",
    component: <NewsDetail />,
  },
  {
    path: "/news/create",
    component: <NewsForm />,
  },
  {
    path: "/news/update/:id",
    component: <NewsForm />,
  },

  {
    path: "/event",
    component: <Event />,
  },
  {
    path: "/event/:id",
    component: <EventDetail />,
  },
  {
    path: "/eventdetails",
    component: <EventDetail />,
  },
  {
    path: "/event/create",
    component: <EventForm />,
  },
  {
    path: "/event/update/:id",
    component: <EventForm />,
  },

  {
    path: "/destination-countries",
    component: <Destination />,
  },
  {
    path: "/destination-countries/create",
    component: <DestinationForm />,
  },
  {
    path: "/destination-countries/update/:id",
    component: <DestinationForm />,
  },
  {
    path: "/destination-countries/detail/:id",
    component: <DestinationDetail />,
  },
  {
    path: "/faq/create",
    component: <FaqCreate />,
  },
  {
    path: "/faq/update/:id",
    component: <FaqCreate />,
  },
  {
    path: "/user",
    component: <User />,
  },
  {
    path: "/user/create",
    component: <User />,
  },
  {
    path: "/user/update/:id",
    component: <User />,
  },
  { path: "/test-preparation", component: <TestPreparation /> },
  { path: "/test-preparation/:id", component: <TestDetail /> },
  { path: "/test-preparation/create", component: <TestCreate /> },
  { path: "/test-preparation/update/:id", component: <TestCreate /> },
  { path: "/menu/create", component: <MenuCreate /> },
  { path: "/media-group", component: <MediaGroup /> },
  { path: "/menu/update/:id", component: <MenuCreate /> },
  { path: "/banner-section", component: <BannerSection /> },
  { path: "/banner-section/update/:id", component: <BannerForm /> },
  { path: "/job-application", component: <JobApplication /> },
  { path: "/job-application/update/:id", component: <AddJob /> },
  { path: "/job-application/detail/:id", component: <JobAppDetail /> },
  { path: "/franchise-enquiry", component: <FranchiseEnquiry /> },
  { path: "/franchise-enquiry/create", component: <FranchiseForm /> },
  { path: "/franchise-enquiry/update/:id", component: <FranchiseForm /> },
  { path: "/news-letter", component: <NewsLetter /> },
  { path: "/news-letter/create", component: <NewsLetterForm /> },
  { path: "/event-forms", component: <EventFormList /> },
  { path: "/footer-info", component: <FooterInfo /> },
  { path: "/footer-info/create", component: <FooterInfoForm /> },
  { path: "/footer-info/update/:id", component: <FooterInfoForm /> },
  { path: "/clear-student-data", component: <ClearStudentForm /> },
  { path: "/email-recipient", component: <EmailRecipient /> },
  { path: "/email-config", component: <EmailConfig /> },
  { path: "/channel-partners", component: <ChannelPartner /> },
  { path: "/assign-institution", component: <ChannelPartnerInstitute /> },
  {
    path: "/institute-intelligence/create/:id",
    component: <InstituteIntellForm />,
  },
  {
    path: "/institute-intelligence/update/:id",
    component: <InstituteIntellForm />,
  },
  { path: "/widgets", component: <Widget /> },
  { path: "/widgets/create", component: <WidgetForm /> },
  { path: "/widgets/update/:id", component: <WidgetForm /> },

   {
    path: "/destination-intelligence/create/:id",
    component: <DestinationIntellForm />,
  },
  {
    path: "/destination-intelligence/update/:id",
    component: <DestinationIntellForm />,
  },
  {path:"/institute-widget",component:<InstituteWidget/>},
  {path:"/destination-widget",component:<DestinationWidget/>},
  {path:"/product-services",component:<ProductService/>},
  {path:"/product-service/create",component:<ProductServiceForm/>},
  {path:"/product-service/update/:id",component:<ProductServiceForm/>},
  {path:"/general-pages",component:<GeneralPages/>},
  {path:"/general-page/create",component:<PageForm/>},
{path:"/franchise-private",component:<FranchisePrivate/>},

];

const publicRoutes = [
  // Authentication Page
  { path: "/", component: <Login /> },

  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/org-register", component: <Register /> },

  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPassword /> },

  { path: "/forgot-password-change", component: <PasswordChange /> },

  //AuthenticationInner pages
  // { path: "/auth-signin-basic", component: <BasicSignIn /> },
  // { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/auth-offline", component: <Offlinepage /> },

  {
    path: "/:orgcode",
    component: <OrgPage />,
  },


  {
    path: "/:orgcode/:page",
    component: <OrgPage />,
  },
  {
    path: "/:orgcode/:page/:subPage",
    component: <OrgPage />,
  },
  {
    path: "*",
    component: <OrgPage />,
  },
];

export { authProtectedRoutes, publicRoutes };
